 
<template>
  <div class="row">
    <div class="col-xl-12"> 
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path != '/AlertReport/BeforeDue'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            
            <h3 class="kt-portlet__head-title "> 
              <i class='text-danger' style="font-size: 0.8em;">* ข้อมูลที่แสดงผลเป็นรูปแบบย้อนหลัง 1 วัน </i>
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form --> 
           <iframe id="ifdashboard" v-if="this.$root.canShow(['super_admin']) && showDashboard" style="height:800px;width:100%;border:none;overflow:hidden;"></iframe>
        
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
 
export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
      var self = this;
      return {
         mbpAgent: null,
         dashboardURL : '/dbs-sit-dashboard/',
         showDashboard: false, // ใช้สำหรับควบคุมการแสดง iframe แบบ lazy
      }
    },
  methods: {
    
  },
  async mounted() {
      let self = this; 
      // รอ 1.5 วินาที ก่อนแสดง iframe เพื่อลดโอกาสเกิด race condition
      if (this.$root.canShow(['super_admin'])) {
          this.showDashboard = true;

          let domain_origin =  window.location.origin ;
          if(domain_origin.indexOf("dbs.boonrawd.co.th")>-1){
            self.dashboardURL = "/dbs-dashboard/";
          }
          let iframURL = domain_origin+""+self.dashboardURL ;

          setTimeout(() => {
                  $("#ifdashboard").attr("src",iframURL);
              }, 500);
      }

      
       
     

  },
};
</script>
 



// WEBPACK FOOTER //
// App/Components/Dashboard/Dashboard.vue